export default "__VITE_ASSET___JO9tM8Q__"